__turbopack_context__.v({
  "autocomplete": "sunfire-forms-module__HpA--G__autocomplete",
  "autocompleteBtn": "sunfire-forms-module__HpA--G__autocompleteBtn",
  "cancelBtn": "sunfire-forms-module__HpA--G__cancelBtn",
  "dropdownContainer": "sunfire-forms-module__HpA--G__dropdownContainer",
  "dropdownSelect": "sunfire-forms-module__HpA--G__dropdownSelect",
  "emptyList": "sunfire-forms-module__HpA--G__emptyList",
  "formContainer": "sunfire-forms-module__HpA--G__formContainer",
  "listContainer": "sunfire-forms-module__HpA--G__listContainer",
  "modal": "sunfire-forms-module__HpA--G__modal",
  "modalButtonContainer": "sunfire-forms-module__HpA--G__modalButtonContainer",
  "pharmacyList": "sunfire-forms-module__HpA--G__pharmacyList",
  "providerDetails": "sunfire-forms-module__HpA--G__providerDetails",
  "rxMenu": "sunfire-forms-module__HpA--G__rxMenu",
  "rxMenuContainer": "sunfire-forms-module__HpA--G__rxMenuContainer",
  "rxSearch": "sunfire-forms-module__HpA--G__rxSearch",
  "saveBtn": "sunfire-forms-module__HpA--G__saveBtn",
  "savedList": "sunfire-forms-module__HpA--G__savedList",
});
